import { render, staticRenderFns } from "./ArrowInBase.vue?vue&type=template&id=fd254b16&scoped=true&"
import script from "./ArrowInBase.vue?vue&type=script&lang=ts&"
export * from "./ArrowInBase.vue?vue&type=script&lang=ts&"
import style0 from "./ArrowInBase.vue?vue&type=style&index=0&id=fd254b16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd254b16",
  null
  
)

export default component.exports